export default async (rows: any[]) =>
  rows.reduce((previous: any, { doc, id }: any): any => {
    // eslint-disable-next-line no-param-reassign
    previous[id] = doc;

    return previous;
  }, {});
